module.exports = __webpack_public_path__ + "img/attachment.78a0c1e0.svg";